import React from 'react';
import Footer from '../components/Footer';
import Locale from '../domain/Locale';
import Color from '../domain/Color';
import { t, props } from 'tcomb-react';

@props({
  header: t.maybe(t.ReactElement),
  sponsor: t.maybe(t.Obj),
  children: t.Any,
  locale: Locale,
  doAcceptCookies: t.maybe(t.Func),
  bgColor: t.maybe(Color),
  color: t.maybe(Color),
  partners: t.maybe(t.Obj)
})
export default class Layout extends React.Component {

  getPartners() {
    if (t.Nil.is(this.props.partners)) {
      return null;
    }

    const partnersStyle = {
      textAlign: this.props.partners.align
    };
    const logos = this.props.partners.logos.map((logo, index) => {
      return (<a key={index} href={logo.link} target="_self"><img src={logo.image} /></a>);
    });
    return (<div id="partners" style={partnersStyle}>{logos}</div>);
  }

  getFooter() {
    return (<Footer locale={this.props.locale} doAcceptCookies={this.props.doAcceptCookies}/>);
  }

  render() {
    const containerHeader1172Style = {
      backgroundColor: this.props.bgColor,
      color: this.props.color
    };

    return (
      <div>
        <div id='modal-container'></div>
        <div id='view'>
          {this.getPartners()}
          <div id='containerHeader1172' style={containerHeader1172Style}>
            <div id='containerHeader960'>
              {this.props.header}
              {this.props.sponsor}
            </div>
          </div>
          <div id='containerBody'>
            <div className='container'>
              {this.props.children}
            </div>
          </div>
          <div id='containerFooter'>
            {this.getFooter()}
          </div>
          <div id='shield'></div>
          <div id='ajax'><div></div></div>
        </div>
      </div>
    );
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/Layout.js
 **/